<template>
    <!-- Panneau latéral gauche (off-canvas) -->
    <div id="menu" class="fixed inset-y-0 left-0 z-[999] w-[85%] max-w-[420px] transform -translate-x-full transition-transform duration-300 will-change-transform
             bg-gradient-to-b from-[#2972db] to-[#163D75]">
        <!-- Conteneur principal -->
        <div class="relative h-full flex flex-col px-4 py-4 text-white">
            <!-- Bouton de fermeture -->
            <button id="close-pannel"
                class="absolute top-4 right-4 inline-flex items-center justify-center h-10 w-10 rounded-full bg-white/15 hover:bg-white/25 transition"
                @click="closeMenu" aria-label="Fermer" title="Fermer">
                <i class="inline-block h-6 w-6 mask mask-close bg-white"></i>
            </button>

            <!-- Header profil -->
            <router-link :to="{ name: 'profil' }" class="mt-10 mb-8 flex items-center gap-4">
                <div class="h-20 w-20 rounded-full bg-center bg-cover ring-2 ring-white/30"
                    :style="`background-image: url(${photoProfil || require('@/img/user-default.png')})`"></div>
                <div class="leading-tight">
                    <h2 class="text-2xl font-bold">{{ last_name }}</h2>
                    <p class="text-lg opacity-90">{{ first_name }}</p>
                    <p class="text-sm text-blue-200 mt-1">
                        <span class="font-semibold">ID client :</span>
                        {{ idOperator }}-{{ idUser }}
                    </p>
                </div>
            </router-link>

            <!-- Zone scrollable #TEST MR Gitlab -->
            <div class="flex-1 overflow-y-auto no-scrollbar pb-6">
                <nav class="space-y-5 text-xl">
                    <router-link :to="{ name: 'home' }" class="flex items-center gap-4 hover:opacity-90 transition">
                        <i class="inline-block h-7 w-7 mask mask-home bg-blue-200"></i>
                        <span>Accueil</span>
                    </router-link>

                    <template v-if="type === 'technicien'">
                        <router-link :to="{ name: 'liste-fibsdd' }"
                            class="flex items-center gap-4 hover:opacity-90 transition">
                            <i class="inline-block h-7 w-7 mask mask-gear-contour bg-blue-200"></i>
                            <span>Interventions</span>
                        </router-link>

                        <router-link :to="{ name: 'ctrl-multi' }"
                            class="flex items-center gap-4 hover:opacity-90 transition">
                            <i class="inline-block h-7 w-7 mask mask-pipe-valve bg-blue-200"></i>
                            <span>Contrôles d'étanchéité multiples</span>
                        </router-link>

                        <router-link :to="{ name: 'contrat-assemblage' }"
                            class="flex items-center gap-4 hover:opacity-90 transition">
                            <i class="inline-block h-7 w-7 mask mask-file bg-blue-200"></i>
                            <span>Contrat d’assemblage</span>
                        </router-link>
                    </template>

                    <router-link :to="{ name: 'liste-detenteurs' }"
                        class="flex items-center gap-4 hover:opacity-90 transition">
                        <i class="inline-block h-7 w-7 mask mask-industry bg-blue-200"></i>
                        <span>Détenteurs & installations</span>
                    </router-link>

                    <router-link :to="{ name: 'liste-bouteilles' }"
                        class="flex items-center gap-4 hover:opacity-90 transition">
                        <i class="inline-block h-7 w-7 mask mask-bouteille-contour bg-blue-200"></i>
                        <span>Bouteilles</span>
                    </router-link>

                    <router-link :to="{ name: 'restitution-bouteilles' }"
                        class="flex items-center gap-4 hover:opacity-90 transition">
                        <i class="inline-block h-7 w-7 mask mask-bouteille-contour bg-blue-200"></i>
                        <span>Restitution bouteilles en volume</span>
                    </router-link>

                    <template v-if="type === 'technicien'">
                        <router-link :to="{ name: 'liste-outils' }"
                            class="flex items-center gap-4 hover:opacity-90 transition">
                            <i class="inline-block h-7 w-7 mask mask-outils bg-blue-200"></i>
                            <span>Outillage</span>
                        </router-link>
                    </template>

                    <!--<template v-if="hasPlanning === true">
                    <router-link :to="{ name: 'agenda' }" class="flex items-center gap-4 hover:opacity-90 transition">
                        <i class="inline-block h-7 w-7 mask mask-calend bg-blue-200"></i>
                        <span>Planning</span>
                    </router-link>
                    </template>-->
                </nav>
            </div>

            <!-- Boutons rapides
                <div class="mt-2 mb-4 grid grid-cols-2 gap-3">
                <a href="fi360://scan?success=tryGoTo" class="text-center py-2 rounded-xl bg-white/15 hover:bg-white/25 font-semibold">
                    Scan Otag Bouteille
                </a>
                <a href="fi360://scan?success=tryGoToInstall" class="text-center py-2 rounded-xl bg-white/15 hover:bg-white/25 font-semibold">
                    Scan Otag Install
                </a>
                </div>-->

            <!-- Lien Support (avec badge) -->
            <router-link v-if="canShowSupport" :to="{ name: 'support' }"
                class="relative flex items-center gap-3 text-lg hover:opacity-90 transition" id="btnSupportMenu">
                <i class="inline-block h-7 w-7 mask mask-question bg-blue-200"></i>
                <span>Demande support</span>

                <!-- Badge compteur -->
                <div v-if="badgeCount > 0"
                    class="absolute -top-2 left-5 w-5 h-5 rounded-full bg-red-600 border-2 border-white flex items-center justify-center">
                    <span class="text-[10px] font-bold text-white leading-none">{{ badgeCount }}</span>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import User from "../../js/models/User";
import Hammer from "hammerjs";
import Operateur from "../../js/models/Operateur";

export default {
    name: "Menu",
    data() {
        return {
            photoProfil: null,
            last_name: null,
            first_name: null,
            type: null,
            idOperator: null,
            idUser: null,
            hasPlanning: false,
            canShowSupport: false,
        };
    },
    computed: {
        badgeCount() {
            return this.$root.badgeCount;
        },
    },
    methods: {
        closeMenu() {
            const p = document.getElementById("menu");
            p && p.classList.remove("open");
            // avec Tailwind : on s'appuie sur la classe .open ci-dessous
        },
    },
    mounted() {
        // Données utilisateur
        User.getUserData((data) => {
            this.photoProfil = data.photo64 && data.photo64 !== "" ? data.photo64 : null;
            this.last_name = data.last_name;
            this.first_name = data.first_name;
            this.type = data.type;
            this.idUser = ("0000" + data.uid).slice(-4);
            this.idOperator = ("0000" + data.operator.id).slice(-4);
        });

        // Option planning
        Operateur.getOperateurOption((options) => {
            this.hasPlanning = options.includes("planning");
        });

        // Swipe pour fermer
        const pannel = document.getElementById("menu");
        const hammerMenu = new Hammer(pannel);
        hammerMenu.on("swipeleft", () => this.closeMenu());

        // Affichage lien Support si token présent
        localforage.getItem("profil").then((raw) => {
            try {
                const user = raw ? JSON.parse(raw) : null;
                let tokenOperator = null;

                if (user && user.operator && user.operator.token) {
                    tokenOperator = user.operator.token;
                }

                this.canShowSupport = tokenOperator !== null;
            } catch (e) {
                this.canShowSupport = false;
            }
        });

    },
};
</script>

<style scoped>
/* État "ouvert" du panneau (on garde la compat avec ton toggle existant) */
#menu.open {
    transform: translateX(0) !important;
}

/* Masquer la scrollbar (optionnel) */
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

.no-scrollbar {
    -ms-overflow-style: none;
    /* IE/Edge */
    scrollbar-width: none;
    /* Firefox */
}
</style>



// WEBPACK FOOTER //
// Menu.vue?42ffdaa0